import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './helpers/initFA';
import App from './App';
import FiltersProvider from './providers/FiltersProvider';
import AuthProvider from './contexts/AuthContext';
import WorkspaceProvider from './contexts/WorkspaceContext';
import reportWebVitals from './reportWebVitals';

try {
  const reactDomModule = require("react-dom");
  if (reactDomModule && typeof reactDomModule.findDOMNode !== "function") {
    reactDomModule.findDOMNode = (target) =>
      target?.current || target?.editor?.root || target?.root || target || null;
  }
} catch (error) {
  // If react-dom can't be required here, react-quill will fall back to its
  // native behavior in environments that still provide findDOMNode.
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <WorkspaceProvider>
        <FiltersProvider>
          <App />
        </FiltersProvider>
      </WorkspaceProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
